import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { Realisation } from 'src/app/classes/realisation';
import { Settlement } from 'src/app/classes/settlement.class';
import { FgWeekDay } from './fg.weekday.class';
import { Week } from './week';

export class WeekDay {
    date: Date;
    type: string;
    fg: FormGroup<ControlsOf<ControlsOf<FgWeekDay>>>;
    fgSecond: FormGroup<ControlsOf<ControlsOf<FgWeekDay>>>;
    realisations: Realisation[];
    settlements: Settlement[];
    sendToAfas: boolean;
    hasUnapprovedRealisations: boolean;
    settling = false;
    week: Week;
    travelTo: string;
    resettleRequired?: boolean;
    /**
     * Valt deze dag binnen de verloonperiode zelf (de kalendermaand)? Weken lopen door buiten de
     * periode, maar alleen dagen binnen de periode tellen mee in de totalen onderaan.
     */
    inPeriod?: boolean;
}
